import { getRandomColor } from 'module/helpers/get-random-color';
import { Select } from '@rocketlane/ui';
import { PeoplePageSourceDerivedSignalSectionConfig } from 'api/custom-section/types';
import { useGetAllSignalConfigurationsQuery } from 'queries/signal';
import { useMemo } from 'react';
import type { Option } from '@rocketlane/ui';

interface Props {
  value?: PeoplePageSourceDerivedSignalSectionConfig['sourceSignalConfigurations'];
  onChange?: (
    value: PeoplePageSourceDerivedSignalSectionConfig['sourceSignalConfigurations'],
  ) => void;
}
export const SignalSelector = ({ value, onChange }: Props) => {
  const { data: allSignals, isLoading: isSignalsLoading } =
    useGetAllSignalConfigurationsQuery();
  const signalOptions = useMemo(
    () =>
      allSignals?.map((signal) => ({
        label: signal.signalName,
        value: signal.signalConfigurationId,
        color: getRandomColor(signal.signalConfigurationId),
      })),
    [allSignals],
  );
  const selectedSignalOptions = useMemo(
    () =>
      value
        ?.map((signal) =>
          signalOptions?.find(
            (option) => option.value === signal.signalConfigurationId,
          ),
        )
        .filter(Boolean),
    [signalOptions, value],
  );
  const onChangeHandler = (value: readonly Option[]) => {
    onChange?.(
      (value as Option[]).map((option: Option) => ({
        signalConfigurationId: option.value as number,
        signalName: option.label,
      })),
    );
  };

  return (
    <Select
      variant="tag"
      options={signalOptions as Option[]}
      value={selectedSignalOptions as Option[]}
      onChange={onChangeHandler}
      isLoading={isSignalsLoading}
      isMulti
    />
  );
};
